// @copyright  2006-2026 West Indies Software Engineering Company Limited. All rights reserved.

/**
 * Stock transfer page routes (warehouse-transfers-and-assignment wp-12,
 * split out of `warehouses.js` by wp-13).
 *
 * Every permission code below was verified against `app_permissions` on
 * 2026-08-20 — see `warehouses.js` for why each guard names a code the wp-01
 * migration actually inserted.
 *
 * The transfer pages arrive with wp-27; this file is imported into
 * `./index.js` when they land — wiring it earlier would point the bundler at
 * page files that do not exist yet. It sits apart from `warehouses.js`
 * precisely so the warehouse and stock screens (wp-13/wp-15) could be wired
 * without dragging these unresolvable imports into the build.
 */
export default [
    {
        path: '/:organisation/inventory/warehouses/transfers',
        component: () =>
            import('@/pages/[organisation]/inventory/warehouses/transfers/index.vue'),
        name: 'inventory.warehouses.search-stock-transfers',
        meta: {
            loginRequired: true,
            permission: 'access.inventory.stock-transfer.search-stock-transfer',
        },
        children: [
            {
                path: 'new',
                component: () =>
                    import('@/pages/[organisation]/inventory/warehouses/transfers/create-transfer.vue'),
                name: 'inventory.warehouses.create-stock-transfer',
                meta: {
                    loginRequired: true,
                    permission: 'access.inventory.stock-transfer.create-stock-transfer',
                },
            },
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/inventory/warehouses/transfers/[id].vue'),
                name: 'inventory.warehouses.view-stock-transfer',
                meta: {
                    loginRequired: true,
                    permission: 'access.inventory.stock-transfer.view-stock-transfer',
                },
            },
        ],
    },
];
